import Swiper, {Scrollbar} from 'swiper';
import {Utils} from '../../common/scripts/utils';

let slider = {};

const awardsSlider = document.querySelector('.j-awards-slider');

const awardsSliderInit = (options) => {
    if (Utils.getWindowWidth() < 1280 && !slider.initialized) {
        slider = new Swiper(awardsSlider, options);
    } else if (Utils.getWindowWidth() > 1279.95 && slider.initialized) {
        slider.destroy();
    }
};

const awardsItems = Array.from(document.querySelectorAll('.j-awards-slide'));


if (awardsSlider) {
    const options = {
        modules             : [Scrollbar],
        loop                : false,
        speed               : 800,
        spaceBetween        : 0,
        slidesPerView       : 'auto',
        slidesOffsetAfter   : 30,
        centeredSlides      : true,
        centeredSlidesBounds: true,
        scrollbar           : {
            el       : '.swiper-scrollbar',
            draggable: true
        }
    };

    awardsSliderInit(options);

    window.addEventListener('resize', () => {
        awardsSliderInit(options);
    });
}

if (awardsItems.length && Utils.getWindowWidth() < 1280) {
    awardsItems.forEach((item) => {
        item.addEventListener('click', () => {
            item.classList.toggle('is-active');
        });
    });
}
